import React, { useState } from "react";
import { Link } from "react-router-dom";
import {AiOutlinePlayCircle} from "react-icons/ai"

import kath from "../../../../assets/katt.png";
import prof from "../../../../assets/k.png";
const MemberTab = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [active,setActive] = useState(2)
    const openPopup = () => {
        setIsOpen(true);
      };
    
      const closePopup = () => {
        setIsOpen(false);
      };



      const plans = [
        {
            month:"12",
            price:"$43.65",
            free:"You save $94.20 over 12 months",
            popular:"Best Value"
        },
        {
            month:"6",
            price:"$45.50 ",
            free:"You save $26.70 over 6 months"
        },
        {
            month:"3",
            price:"$47.50 ",
            free:"Free $70 Necklace Included",
            popular:"Most Popular"
        },
        {
            month:"1",
            price:"$49.95",
            free:"No Commitment"
        },
      ]


      function memberLink () {
         switch (active) {
            case 0:
              window.location.href = "https://checkout.myirelandbox.com/checkout/buy/142484"
              break;
            case 1:
                window.location.href = "https://checkout.myirelandbox.com/checkout/buy/142482"
                break;
            case 2:
                window.location.href = "https://checkout.myirelandbox.com/checkout/buy/142005"
              break;
              case 3:
                window.location.href = "https://checkout.myirelandbox.com/checkout/buy/142652"
                break;
            default:
        }
      }
    return (
          <div className="member-bck">
            <div className="membertab-heading">
            <p>Choose a plan</p>
            <h1>My Ireland Box Subscriptions</h1>
            </div>
             <div className="member-container">
             {isOpen && (
          <div className="popup-overlay" >
          <div className="popup">
            <div className="popup-content">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/6vynZylkmao" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

              <div className="popUp-description">
              <div>
            <img src={prof} alt=""/>
            <p className="kath">Katharine Keane Barrett</p>
           </div>
           <p className="popUp-scroll">Big hello (Dia Dhuit in Gaelic!) to you!
I also want to tell you about MyIrelandBox and why I began, in 2013, to send a box full of Irish-made surprises, hand-picked by me, to people that loved Ireland and maybe missed it. Well, it began really when I was expecting my first child, Kate (now 10 years old!) and I was working as a lawyer and at the weekends meeting many people from the USA and Canada that were in Dingle town on vacation and expressing how sad they were to be going home and how much they would miss Ireland. It occurred to me that there must be so many people abroad that had Irish roots and that would just love to visit Ireland but for some reason or other, perhaps could not. So, I thought that it would be a lovely idea to bring Ireland to them. So, I established MyIrelandBox and decided that I would send everyone that wanted one, a MyIrelandBox full of the Irish made products that I loved - books that would transport them to Ireland, Celtic jewellery that would put a smile to everyone's face, beautiful and useful Irish hand-made homewares made by our most talented craftspeople, Gaelic words and phrases to spread the joy of our language and much more. I began writing a letter to everyone and I continue that every month and I continue that every month, now within a Booklet from Ireland, and I love it! When you have a passion for Ireland, Irish tradition and culture - it becomes a mission to share it with those who also love everything about Ireland.
I am from Dingle, Co. Kerry, where my ancestors are also from. I have a passion for Gaelic, Irish music, Irish poetry and writing, Irish craft and the beautiful Celtic jewelry that is made in Ireland and especially the traditions and culture of our forefathers and those that carry them on today. I love to share it with MyIrelandBox members every month though a curation from my heart, in to the homes of MyIrelandBox members. </p> 

           <div className="popUp-buttons">
            <Link to="/get-started" alt="#">Subscribe Today</Link>
            <Link to="/gifting-form"  alt="#">View More</Link>
           </div>
           </div>
              <button  onClick={closePopup}>X</button>
            </div>
          </div>
        </div>
      )}
            <div className="play-popUp" onClick={openPopup}>
                <img src={kath} />

                <div className="play-content" > 
                <h1 >Unboxing a MyIrelandBox with Katharine</h1>
                <h1>Katharine</h1>
                <p className="hoverable"><AiOutlinePlayCircle/>Play video</p>
                </div>
            </div>
            <div className="memebrTab-display">
                {plans.map((item,i) =>{
                   return(
                    <div className={`member-tab ${active === i ? "member-ac" : ""}`} onClick={() => {setActive(i)}} >
                        <p className="member-position" style={{background:item.month === "12" ? "#86A141" : "" }}>{item.popular}</p>
                    <div className="membere-mmonth">
                        <h1>{item.month}</h1>
                        <p>Month</p>
                    </div>
                    <div>
                        <div className="member-price"><h1>{item.price}</h1><span>per box</span></div>
                        <p className="member-free">{item.free}</p>
                    </div>
                 </div>
                   )
                })}
                 


                 <button className="member-button" onClick={memberLink}>Select This Plan!</button>
            </div>
        </div>
          </div>
    )
}

export default MemberTab;